
if ( typeof VideoBackgroundElement !== 'function' ) {

  class VideoBackgroundElement extends HTMLElement {

    constructor(){
      super();
      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');

      video.addEventListener('error', e => {
        this.switchFallback();
      });
      video.addEventListener('playing', e => {
        if ( ! this.classList.contains('loaded') ) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      });
      video.addEventListener('stalled', e => {
        if ( ! this.classList.contains('loaded') ) {
          this.switchFallback();
        }
      });

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if ( ( entries[0].target.querySelector('video-background-element') && ! entries[0].target.querySelector('video-background-element').classList.contains('loaded') ) || ( entries[0].tagName == 'video-background-element') && ! entries[0].target.classList.contains('loaded') ) {
          this.loadVideoSources(video);
        }
        observer.unobserve(this);
      };

      if ( this.getBoundingClientRect().y < window.innerHeight || this.parentNode.getBoundingClientRect().y < window.innerHeight ) {
        this.loadVideoSources(video);
      } else {
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 800px 0px`}).observe(this);
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 800px 0px`}).observe(this.parentElement);
      }
    }

    switchFallback(){
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }

    loadVideoSources(video) {
      // Already loaded (sources with real src already in video)
      if ( video.querySelector('source[src]') ) return true;

      // New approach: sources stored in <template class="video-sources"> (no src in live DOM)
      const template = this.querySelector('template.video-sources');
      if ( template ) {
        const sources = template.content.querySelectorAll('source');
        if ( sources.length === 0 ) return false;
        sources.forEach(source => {
          video.appendChild(source.cloneNode(true));
        });
        video.load();
        video.play().catch(() => {});
        return true;
      }

      // Old approach: sources already in video with data-src
      const sources = video.querySelectorAll('source[data-src]');
      if ( sources.length === 0 ) return false;
      sources.forEach(elm => {
        elm.src = elm.dataset.src;
      });
      video.load();
      return true;
    }
  }

  if ( typeof customElements.get('video-background-element') == 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }

}

document.addEventListener('shopify:section:load', e => {
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(() => {
      e.target.querySelectorAll('video-background-element').forEach(elm => {
        elm.loadVideoSources(elm.querySelector('video'));
      });
    }, 500);
  }
});
